module.exports = __webpack_public_path__ + "img/team-12.e0c2e2cd.jpg";